<template>
  <div
    class="item-container"
    :class="{
      'active-item': active,
      'done-item': done,
      'first-item': first,
      'last-item': last,
    }"
  >
    <div class="bullet">
      <v-icon v-if="done" color="text" :size="36" style="position: absolute">
        mdi-check
      </v-icon>
      <div class="title">{{ title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepperItem",

  props: {
    active: { type: Boolean, default: false },
    done: { type: Boolean, default: false },
    first: { type: Boolean, default: false },
    last: { type: Boolean, default: false },
    title: { type: String },
  },
};
</script>

<style lang="scss" scoped>
.item-container {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  & .bullet {
    position: relative;
    background-color: var(--v-midGrey-base);
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    & .title {
      position: static;
      padding-top: 100px;
      white-space: nowrap;
      font-size: 16px !important;
      color: var(--v-midGrey-base);
    }
  }
}
.active-item {
  background-color: var(--v-secondaryYellow-base);
  border: 2px solid var(--v-text-base);
  min-width: 48px;
  height: 48px;
  & .bullet {
    background-color: var(--v-text-base);
    & .title {
      font-size: 20px !important;
      color: var(--v-text-base);
    }
  }
}
.done-item {
  background-color: var(--v-secondaryYellow-base);
  border: 2px solid var(--v-text-base);
  min-width: 48px;
  height: 48px;
  & .bullet {
    background: none !important;
    & .title {
      color: var(--v-text-base);
    }
  }
}
.first-item {
  & .title {
    margin-left: -90px;
  }
}
.last-item {
  & .title {
    margin-right: -40px;
  }
}
</style>
